import { Badge } from "@thilke/ui/components/badge";
import { AlertCircleIcon, CheckIcon } from "lucide-react";

export function BadgeDemo() {
  return (
    <div className="flex flex-col items-start gap-2">
      <div className="flex w-full flex-wrap gap-2">
        <Badge>Badge</Badge>
        <Badge variant="secondary">Secondary</Badge>
        <Badge variant="destructive">Destructive</Badge>
        <Badge variant="outline">Outline</Badge>
        <Badge variant="success">
          <CheckIcon /> Success
        </Badge>
        <Badge variant="warning">Warning</Badge>
        <Badge variant="info">Info</Badge>
        <Badge variant="accent">Accent</Badge>
        <Badge variant="destructive">
          <AlertCircleIcon /> Alert
        </Badge>
      </div>
    </div>
  );
}
